// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","link":"KlZz8 DIwTU a8cCT"};